import { render, staticRenderFns } from "./Chatroom.vue?vue&type=template&id=6a057cdf&"
import script from "./Chatroom.vue?vue&type=script&lang=js&"
export * from "./Chatroom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports